function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @namespace source.items
 */
import { LimitedCache } from '../../utils/LimitedCache';
import { toItem } from './mappers/item';
import { toBackendItem } from './mappers/backend-item';
import { toError } from './parsers/error';
var listResponseCache = new LimitedCache(Infinity);
export function initItems(settings, http) {
  function mapItemList(items, thumbnailSizes) {
    var existingItems = (items || []).filter(function (item) {
      return item.src_info;
    });
    return existingItems.map(function (data) {
      return toItem(data, settings, thumbnailSizes);
    });
  }

  var defaultPaging = {
    size: 50,
    cursor: null
  };
  var defaultSort = {
    order: 'date',
    direction: 'desc'
  };
  /**
   * @summary Returns the list of items
   * @memberof source.items
   * @param {ListSettings} options
   * @returns {Promise}
   * @fulfill {List}
   * @reject {Error}
   */

  function list(folderId, options) {
    if (options === void 0) {
      options = {};
    }

    var cacheKey = "" + folderId + JSON.stringify(options);

    if (settings.useCache && listResponseCache.has(cacheKey)) {
      return listResponseCache.get(cacheKey);
    }

    var sort = _objectSpread({}, defaultSort, {}, options.sort);

    var paging = _objectSpread({}, defaultPaging, {}, options.paging);

    var queryParams = {
      page_size: paging.size,
      cursor: paging.cursor,
      order: sort.direction === 'desc' ? "-" + sort.order : sort.order,
      tag: options.tag,
      source_type: options.kind
    };

    if (options.mediaType) {
      queryParams.media_type = options.mediaType.split(',').concat(['folder']).join(',');
    }

    var promise = http.get(settings.apiUrl + "/site/media/favs", queryParams, {
      headers: options.headers || {}
    }).then(function (response) {
      return _objectSpread({}, response, {
        paging: {
          size: paging.size,
          cursor: response.data.cursor
        },
        data: mapItemList(response.data.items, options.thumbnails)
      });
    })["catch"](toError);

    if (settings.useCache) {
      listResponseCache.set(cacheKey, promise);
    }

    return promise;
  }
  /**
   * @summary Remove passed items from favorites
   * @memberof source.items
   * @param {object} item
   * @returns {Promise}
   */


  function remove(items, options) {
    if (options === void 0) {
      options = {};
    }

    var queryParams = {};
    var url = settings.apiUrl + "/site/media/favs";
    var postOptions = {
      headers: options.headers || {}
    };
    var data = items.map(function (item) {
      return item.id;
    });
    return http.del(url, {
      items: data
    }, queryParams, postOptions).then(function (res) {
      listResponseCache.clear();
      res.data = items;
      return res;
    })["catch"](toError);
  }
  /**
   * @summary Add the item with given id
   * @memberof source.items
   * @param {Array} items
   * @returns {Promise}
   */


  function add(items, options) {
    if (options === void 0) {
      options = {};
    }

    var url = settings.apiUrl + "/site/media/favs";
    var postOptions = {
      headers: options.headers || {}
    };
    var data = items.map(function (item) {
      return toBackendItem(item);
    });
    return http.post(url, {
      items: data
    }, null, postOptions).then(function (response) {
      listResponseCache.clear();
      return _objectSpread({}, response, {
        data: mapItemList(response.data.items, options.thumbnails)
      });
    })["catch"](toError);
  }

  function clearCache() {
    listResponseCache.clear();
  }

  return {
    add: add,
    list: list,
    remove: remove,
    clearCache: clearCache
  };
}